import React from 'react';
import { Helmet } from 'react-helmet';

import Paper from '@material-ui/core/Paper';
import Slide from '@material-ui/core/Slide';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { makeStyles, withStyles } from '@material-ui/core/styles';

// import noDataImage from 'assets/zero-state-images/no-data.svg';

import LogoText from 'components/logoText';
// import ZeroStateView from 'components/ZeroStateView';

import Canvas from './canvas';

const useStyles = makeStyles((theme: Object) => ({
  buttonRoot: {
    borderRadius: '50%',
  },
  color: {
    borderRadius: '50%',
    height: '50px',
    width: '50px',
  },
  content: {
    maxWidth: 1152,
    margin: '0  auto !important',
    '@media (min-width: 769px)': {
      marginLeft: theme.defaults.content.paddingLeft,
      marginRight: theme.defaults.content.paddingRight,
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    height: 64,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: 'transparent',
    padding: 8,
    marginBottom: 32,
    marginTop: 32,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      margin: 0,
    },
  },
  paper: {
    borderTop: '4px solid #F5A623',
    padding: 48,
    minWidth: 200,
    width: '100%',
    boxShadow: '0 8px 24px 0 rgba(0, 0, 0, 0.15)',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      padding: 24,
      margin: 16,
      background: 'none',
    },
  },
}));

// const renderZeroState = () => {
//   return (
//     <ZeroStateView
//       iconSize={{width: 115, height: 115}}
//       icon={noDataImage}
//       primary={`Sorry, we cannot connect to our services. Pleea`}
//       textOnTop
//     />
//   );
// };

const StyledToggleButtonGroup = withStyles((theme) => ({
  grouped: {
    margin: theme.spacing(0.5),
    border: 'none',
    padding: theme.spacing(0, 1),
    '&:not(:first-child)': {
      borderRadius: theme.shape.borderRadius,
    },
    '&:first-child': {
      borderRadius: theme.shape.borderRadius,
    },
  },
}))(ToggleButtonGroup);

const OfflinePage = () => {
  const classes = useStyles();

  return (
    <>
      <Helmet>
        <title>Can&quot;t Offline</title>
        <meta name="offline" content="Offline"/>
      </Helmet>

      <div className={classes.content} >
        <div className={classes.header}>
          <LogoText/>
        </div>

        <Slide direction="up" in appear mountOnEnter unmountOnExit>
          <Paper
            className={classes.paper}
            square
          >
            <StyledToggleButtonGroup>
              <ToggleButton
                aria-label="color-1"
                className={classes.color}
                classes={{
                  root: classes.buttonRoot,
                }}
                value="color-1"
              />
              <ToggleButton className={classes.color} value="blue" aria-label="blue" />
              <ToggleButton className={classes.color} value="green" aria-label="green" />
            </StyledToggleButtonGroup>
            <Canvas />
          </Paper>
        </Slide>
      </div>
    </>
  );
};

export default OfflinePage;
